import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { EmptyDashButtonsContainer } from "./DashboardStyles-v2";

export const EmprtyDashboard = () => {
    const t = useTranslation();
    return (
        <EmptyDashButtonsContainer>
            <div className="inside-full">
                <div className="addWidgetContainer">
                    <h3 className="addWidgetContainer-title">{t("home.dashboards.add.widget")}</h3>
                    <p className="addWidgetContainer-text">
                        {t("home.dashboards.add.widget.1", {
                            buttonText: t("home.dashboards.add.widget.2"),
                        })}
                    </p>

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="440"
                        height="249"
                        viewBox="0 0 440 249"
                    >
                        <g
                            fill="none"
                            fillRule="evenodd"
                        >
                            <path
                                fill="#FFF"
                                stroke="#CAE4FE"
                                strokeDasharray="5.472000148773191,5.472000148773191"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.736"
                                d="M134.97 2c.176 66.517.214 108.653-1.029 111.003-28.387 4.842-131.353 2.708-131.353 1.666C2.588 108.834 2 14.544 2 2.21L134.97 2z"
                            />
                            <path
                                fill="#CAE4FE"
                                d="M74.197 36.835c-17.34-3-30.088 18.525-18.184 32.163 14.416 16.515 36.054.706 34.254-12.308-.982-15.018-10.082-18.819-16.07-19.855z"
                            />
                            <g
                                stroke="#FFF"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.709"
                            >
                                <path d="M60.754 56.183c6.81-.238 14.01-.099 20.767-.779M71.211 47.502c-.224 5.86-.454 11.688-.147 17.54" />
                            </g>
                            <path
                                fill="#FF8700"
                                d="M183.935 177.922c27.286-28.628 20.941-32.044 43.679.97"
                            />
                            <path
                                fill="#FF8100"
                                d="M161.255 138.96c-.165 64.35.383 109.284-.317 109.284-25.348 0 121.629.077 122.387-1.332 3.343-6.213 1.099-108.8.55-108.8-.55 0-122.62.848-122.62.848z"
                            />
                            <path
                                fill="#D56C00"
                                d="M202 189.738c3.48 5.145 19.708 20.164 19.899 19.972 1.068-1.08 18.143-17.881 20.69-20.71l-40.589.738z"
                            />
                            <path
                                fill="#D56C00"
                                fillRule="nonzero"
                                d="M215 166h15.878v27.249H215z"
                            />
                            <path
                                stroke="#D56C00"
                                strokeWidth="5.32"
                                d="M200 218.619h44.247"
                            />
                            <g>
                                <path
                                    fill="#FFC100"
                                    d="M287.144 3.884c0 42.513.726 111.711 0 111.785-11.82 1.201-93.414 0-128.788 0-1.944 0-1.666-107.547 0-111.785 1.666-4.239 134.154 0 128.788 0z"
                                />
                                <path
                                    stroke="#FFF"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.736"
                                    d="M182.972 38.3c1.827-2.036 3.421-4.41 4.782-6.844 3.12-5.582 1.214-17.504-2.39-9.98-3.59 7.489 1.652 20.115 9.564 15.397 3.466-2.066 12.824-14.607 4.543-16.253-4.788-.952-4.287 14.8.239 16.824 7.666 3.428 20.052-10.02 12.912-18.535-3.826-4.563-7.507 14.6.956 17.964 9.072 3.607 22.633-11.337 14.586-18.534-4.915-4.396-5.203 11.06-3.826 13.687 8.496 16.212 23.043-8.502 17.694-11.691-4.08-2.434-4.858 7.054-4.304 9.695 1.762 8.403 15.005 5.988 20.563 5.988M182.972 69.413c1.827-2.035 3.421-4.409 4.782-6.844 3.12-5.581 1.214-17.503-2.39-9.98-3.59 7.49 1.652 20.115 9.564 15.398 3.466-2.067 12.824-14.607 4.543-16.254-4.788-.951-4.287 14.8.239 16.824 7.666 3.429 20.052-10.02 12.912-18.534-3.826-4.563-7.507 14.6.956 17.964 9.072 3.606 22.633-11.337 14.586-18.535-4.915-4.396-5.203 11.06-3.826 13.687 8.496 16.212 23.043-8.501 17.694-11.69-4.08-2.434-4.858 7.053-4.304 9.694 1.762 8.403 15.005 5.989 20.563 5.989M193.87 83.64l74.57-1.58M169.039 99.052l97.953-1.536"
                                />
                            </g>
                            <g>
                                <path
                                    fill="#CAE4FE"
                                    d="M138.635 136c.178 66.13.748 111.116 0 111.195-12.183 1.28-97.26 0-132.743 0-2.007 0 0-111.195 0-111.195h132.743z"
                                />
                                <g transform="translate(34 155)">
                                    <circle
                                        cx="38"
                                        cy="38"
                                        r="38"
                                        fill="#4F8DF9"
                                        transform="rotate(-90 38 38)"
                                    />
                                    <path
                                        fill="#1B2653"
                                        d="M39 0c20.272.361 36.639 16.728 37 37H39V0z"
                                    />
                                    <path
                                        fill="#FFF"
                                        d="M64 10.05L39 37V0a37.68 37.68 0 0 1 25 10.05z"
                                    />
                                </g>
                            </g>
                            <g>
                                <path
                                    fill="#4F8DF9"
                                    d="M310.4 4c-1.888 28.783-2.89 114.832-2.162 114.923 21.335 2.671 128.222-.338 128.222-1.39 0-5.89 3.041-95.059.576-113.533H310.4z"
                                />
                                <path
                                    stroke="#FFF"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.2"
                                    d="M335 26v60h74"
                                />
                                <path
                                    stroke="#FFF"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.2"
                                    d="M347 54h11v32h-11zM367 47h11v39h-11zM387 34h11v52h-11zM346 94h11M367 94h11M388 94h11"
                                />
                                <path
                                    stroke="#CFE6FD"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.2"
                                    d="M413 18h11M413 24h11M413 30h11"
                                />
                            </g>
                            <g>
                                <path
                                    fill="#FFC100"
                                    d="M439.524 139.803c0 40.686.761 106.91 0 106.98-12.4 1.15-97.993 0-135.102 0-2.04 0-1.747-102.924 0-106.98 1.748-4.057 140.73 0 135.102 0z"
                                />
                                <path
                                    fill="#FFA600"
                                    d="M335.38 166.5h72.24c-11.445 41.078-23.486 61.617-36.12 61.617-12.634 0-24.675-20.54-36.12-61.617z"
                                />
                                <path
                                    fill="#FFF"
                                    d="M397.535 197c-8.378 20.745-17.057 31.117-26.035 31.117-8.978 0-17.657-10.372-26.035-31.117h52.07z"
                                />
                                <path
                                    fill="#FF8100"
                                    d="M402.914 182c-2.932 8.977-5.902 16.644-8.91 23H348.91c-3.008-6.356-5.978-14.023-8.91-23h62.914z"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </EmptyDashButtonsContainer>
    );
};
